import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Dialog,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { DatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useContext, useEffect, useMemo, useState } from 'react';
import CustomTableSortLabel from '../../components/custom-table-sort-label/CustomTableSortLabel';
import PageTitle from '../../components/page-title/PageTitle';
import { useMedicalCertificateService } from '../../hooks/services/useMedicalCertificateService';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import IMedicalCertificate from '../../interfaces/IMedicalCertificate';
import IPage from '../../interfaces/IPage';
import { Container } from './FollowupList.styled';
import CustomTablePagination from '../../components/custom-table-pagination/CustomTablePagination';
import moment from 'moment';
import { TbReload } from 'react-icons/tb';
import FollowupDetail from './FollowupDetail';
import Transition from './FollowupTransition';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SelectCheckbox from '../../components/select-form/SelectCheckbox';
import ISelectOption from '../../components/select-form/interfaces/ISelectOption';
import FollowupListRow from './FollowupListRow';
import FollowupSearchEmployee from './FollowupSearchEmployee';
import IEmployee from '../../interfaces/IEmployee';
import UserContext from '../../context/user/UserContext';
import SearchDocumentType from '../../components/searchDocumentType/SearchDocumentType';
import ITypeDocument from '../../interfaces/ITypeDocument';
import SearchLocal from '../../components/searchLocal/SearchLocal';
import ILocal from '../../interfaces/ILocal';
import { useTenantService } from '../../hooks/services/useTenantService';
import ITenant from '../../interfaces/ITenant';
import SearchCostCenter from '../../components/searchCostCenter/SearchCostCenter';
import ICostCenter from '../../interfaces/ICostCenter';
import ICompany from '../../interfaces/ICompany';
import SearchCompany from '../../components/searchCompany/SearchCompany';
import ISubsidiary from '../../interfaces/ISubsidiary';
import SearchSubsidiary from '../../components/searchSubsidiary/SearchSubsidiary';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { EVENTOS_WIDTH, getBaseCellProps, getStickyProps, getStickyRightProps, HeaderConfig } from '../../hooks/util/useStickTable';
import { getTimeQuanitity } from './followupUtil';
import useCpfCnpjFormat from '../../hooks/util/useCpfCnpjFormat';
import FollowupStatus from './FollowupStatus';
import { useMatch, useNavigate } from 'react-router-dom';
import { hasAccessToAction, isManagerOnly } from '../../util/hasAccessTo';
import ManageSearchSharpIcon from '@mui/icons-material/ManageSearchSharp';

interface FollowupListProps extends IPage { }

const statusFilters = [
  { value: 'PENDING', label: 'Pendente' },
  { value: 'APPROVED', label: 'Aprovado' },
  { value: 'APPROVEDBYMANAGER', label: 'Aprovado pelo gestor' },
  { value: 'DISAPPROVED', label: 'Reprovado' },
  { value: 'DISAPPROVEDBYMANAGER', label: 'Reprovado pelo gestor' },
  { value: 'ARCHIVED', label: 'Arquivado' },
  { value: 'ARCHIVEDBYMANAGER', label: 'Arquivado pelo gestor' },
];

const managerStatusFilters = [
  { value: 'PENDING', label: 'Pendente' },
  { value: 'APPROVEDBYMANAGER', label: 'Aprovado pelo gestor' },
  { value: 'DISAPPROVEDBYMANAGER', label: 'Reprovado pelo gestor' },
  { value: 'ARCHIVEDBYMANAGER', label: 'Arquivado pelo gestor' },
];

const statusIntegration = [
  { value: 'TODOS', label: 'Todos' },
  { value: 'SUCCESS', label: 'Sim' },
  { value: 'ERROR', label: 'Não' },
];
const statusDrafts = [
  { index: '0', value: true, label: 'Sim' },
  { index: '1', value: false, label: 'Não' },
];

const FollowupList = (props: FollowupListProps) => {
  window.document.title = props.title;

  const { state } = useContext(UserContext);
  const [allDocumentIds, setAllDocumentIds] = useState<string[]>([]);
  const [originalPage, setOriginalPage] = useState<number | null>(null);
  const [medicalCertificates, setMedicalCertificates] = useState<IMedicalCertificate[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>('asc');
  const [orderField, setOrderField] = useState<string>('createdAt');
  const [loading, setLoading] = useState(false);
  const [employee, setEmployee] = useState<IEmployee | null>(null);
  const [local, setLocal] = useState<ILocal | null>(null);
  const [onlyAlerts, setOnlyAlerts] = useState(false);
  const [protocolNumber, setProtocolNumber] = useState('');
  const [costCenters, setCostCenters] = useState<ICostCenter | null>(null);
  const [company, setCompany] = useState<ICompany | null>(null);
  const [subsidiary, setSubsidiary] = useState<ISubsidiary | null>(null);

  const [statusSelected, setStatusSelected] = useState<ISelectOption[]>([{ value: 'PENDING', label: 'Pendente' }]);
  const [integrationSelected, setIntegrationSelected] = useState<string>('TODOS');
  const [allowDrafts, setAllowDrafts] = useState<boolean>(false);
  const [typeDocument, setTypeDocument] = useState<ITypeDocument | null>(null);

  const [initialDate, setInitialDate] = useState<moment.Moment | null>(
    moment(new Date())
      .subtract(5, 'days')
      .startOf('day'),
  );
  const [tenant, setTenant] = useState<ITenant | null>(null);
  const [seeCID, setSeeCid] = useState<boolean>(false);

  const [finalDate, setFinalDate] = useState<moment.Moment | null>(moment(new Date()).endOf('day'));

  const { formatCpf } = useCpfCnpjFormat();
  const navigate = useNavigate();

  const headers: HeaderConfig[] = [
    {
      field: 'protocolNumber', label: 'Protocolo',
      render: (row) => row.protocolNumber,
    },
    {
      field: 'company', label: 'Empresa',
      render: (row) => `${row.employee?.company?.code} - ${row.employee?.company?.name}`,
    },
    {
      field: 'employee_code', label: 'Matrícula', sticky: true, width: 100,
      render: (row) => row.employee?.code,
    },
    {
      field: 'employee_name', label: 'Colaborador', sticky: true, width: 200,
      render: (row) => row.employee?.name,
    },
    {
      field: 'employee_cpf', label: 'CPF Colaborador',
      render: (row) => formatCpf(`${row.employee?.cpf}`),
    },
    {
      field: 'createdAt', label: 'Data do Envio',
      render: (row) => moment(row.createdAt).format('DD/MM/yyyy HH:mm'),
    },

    {
      field: 'documentDate', label: 'Data do Documento',
      render: (row) => moment(row.documentDate).format('DD/MM/yyyy'),
    },
    {
      field: 'timeQuantity', label: 'Tempo',
      render: (row) => getTimeQuanitity(row),
    },
    {
      field: 'diseaseClassification_code', label: 'CIDs',
      render: (row) => {
        if (!seeCID) return '****';
        const dc = row.diseaseClassifications?.[0];
        return dc?.code || '';
      },
    },
    {
      field: 'status', label: 'Situação',
      render: (row) => <FollowupStatus status={row.status} />,
    },
    {
      field: 'typeDocument_description', label: 'Tipo de documento',
      render: (row) => row.typeDocument?.description,
    },
    {
      field: 'statusIntegration',
      label: 'Integrado',
      render: (row) => row.statusIntegration === 'SUCCESS' ? 'Sim' : 'Não',
    },
    {
      field: 'isDraft',
      label: 'Rascunho',
      render: (row) => row.isDraft ? 'Sim' : 'Não',
    },
  ];

  const request = useMedicalCertificateService();
  const requestTenant = useTenantService();
  const toastr = useToastrVanila();

  interface IFilter {
    status?: ISelectOption[];
    initialDate?: string;
    finalDate?: string;
    employeeId?: string | null;
    localId?: string | null;
    companyId?: string | null;
    subsidiaryId?: string | null;
    statusIntegration?: string;
    onlyAlerts?: boolean;
    protocolNumber?: string | null;
    costCenterId?: string | null;
  }

  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    orderDirection: 'asc' | 'desc',
    filters?: IFilter,
  ) => {
    setLoading(true);

    const status = filters?.status?.map(s => s.value) || statusSelected.map(s => s.value);
    const statusIntegration = filters?.statusIntegration || integrationSelected;

    const auxInitialDate = filters?.initialDate || initialDate?.format('yyyy-MM-DD');
    const auxFinalDate = filters?.finalDate || finalDate?.format('yyyy-MM-DD');
    const employeeId = filters?.employeeId || `${employee?.id}`;
    const localId = filters?.localId || `${local?.id}`;
    const alerts = filters?.onlyAlerts || onlyAlerts;
    const protocol = filters?.protocolNumber || protocolNumber;
    const costCenterId = filters?.costCenterId || `${costCenters?.id}`;
    const companyId = filters?.companyId || `${company?.id}`;
    const subsidiaryId = filters?.subsidiaryId || `${subsidiary?.id}`;

    await request
      .listForFollowup(perPage, currentPage + 1, orderField, orderDirection, {
        status,
        initialDate: `${auxInitialDate}`,
        finalDate: `${auxFinalDate}`,
        employeeId,
        localId,
        statusIntegration,
        onlyAlerts: alerts,
        protocolNumber: protocol,
        allowDrafts,
        typeDocumentId: typeDocument?.id,
        costCenterId: costCenterId,
        companyId: companyId,
        subsidiaryId: subsidiaryId,
      })
      .then(result => {
        setMedicalCertificates([...result.data]);
        setTotalRows(result.totalRows);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        toastr.error(error.message);
      });
  };

  const getTenant = async () => {
    setLoading(true);
    await requestTenant
      .getTenant()
      .then(result => {
        setTenant({ ...result });
        setLoading(false);
      })
      .catch(error => {
        toastr.error(error.message);
        setLoading(false);
      });
  };

  // Usuário que só possui o perfil de gestor (nenhum outro perfil que já enxerga CID)
  const managerOnly = useMemo(
    () => isManagerOnly(state.resourcesWithActions),
    [state.resourcesWithActions]
  );

  // Só decide depois que o tenant carregou; até lá o CID fica oculto (estado inicial false)
  useEffect(() => {
    if (!tenant) return;
    setSeeCid(!(managerOnly && !tenant.showCIDForManager));
  }, [tenant, managerOnly]);

  useEffect(() => {
    list(perPage, currentPage, orderField, orderDirection);
    getTenant();
  }, []);

  useEffect(() => {
    setAllDocumentIds([]);
    setOriginalPage(null);
    list(perPage, 0, orderField, orderDirection);
  }, [
    employee,
    perPage,
    statusSelected,
    integrationSelected,
    initialDate,
    finalDate,
    onlyAlerts,
    local,
    protocolNumber,
    allowDrafts,
    typeDocument,
    costCenters,
    company,
    subsidiary
  ]);

  const canView = hasAccessToAction(
    ["followup-atestado-web"],
    state.resourcesWithActions,
    "Visualizar"
  );

  const match = useMatch('/followup/editar-atestado/:id')
  const detailId = canView ? match?.params?.id : undefined;

  // A lista de IDs na ordem atual (filtrada e ordenada). Obs: Se a lista foi resetada (vazia), reconstrói do zero
  useEffect(() => {
    const newIds = medicalCertificates.map((mc) => String(mc.id));
    setAllDocumentIds((prev) => {
      if (prev.length === 0) return newIds;
      const set = new Set(prev);
      const merged = [...prev];
      newIds.forEach((id) => {
        if (!set.has(id)) merged.push(id);
      });
      return merged;
    });
  }, [medicalCertificates]);


  const handleOpenDetail = (mc: IMedicalCertificate) => {
    navigate(`/followup/editar-atestado/${mc.id}`);
  };

  const totalPages = Math.ceil(totalRows / perPage);
  const fetchPage = async (direction: 'next' | 'prev'): Promise<boolean> => {
    const targetPage = direction === 'next' ? currentPage + 1 : currentPage - 1;
    if (targetPage < 0 || targetPage >= totalPages) return false;

    if (originalPage === null) {
      setOriginalPage(currentPage);
    }

    await list(perPage, targetPage, orderField, orderDirection);
    setCurrentPage(targetPage);
    return true;
  };

  const handleCloseDetail = () => {
    // Limpa os IDs para que sejam reconstruídos com a lista atualizada
    setAllDocumentIds([]);
    // Restaura a página original se navegou entre páginas
    if (originalPage !== null) {
      list(perPage, originalPage, orderField, orderDirection);
      setCurrentPage(originalPage);
      setOriginalPage(null);
    } else {
      list(perPage, currentPage, orderField, orderDirection);
    }
    navigate('/followup');
  };

  return (
    <Container>
      <Dialog fullScreen open={!!detailId} TransitionComponent={Transition}>
        {detailId && (
          <FollowupDetail
            key={detailId}
            medicalCertificateId={detailId}
            employeeId={Number(
              medicalCertificates.find((mc) => String(mc.id) === detailId)?.employeeId
            )}
            closeDialog={handleCloseDetail}
            isOpen={!!detailId}
            documentIds={allDocumentIds}
            totalRows={totalRows}
            onRequestPage={fetchPage}
            hasNextPage={currentPage < totalPages - 1}
            hasPrevPage={currentPage > 0}
          />
        )}
      </Dialog>

      <PageTitle title="ACOMPANHAMENTO DE ATESTADOS">
        <Tooltip title="Atualizar dados" placement="left">
          <IconButton onClick={() => list(perPage, currentPage, orderField, orderDirection)}>
            <TbReload />
          </IconButton>
        </Tooltip>
      </PageTitle>
      <Box sx={{ marginTop: 1 }}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
            <Typography variant="body1" sx={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 1 }}>
              Filtros
            </Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item md={4} sm={12} xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', mb: 1, fontWeight: 500 }}>
                  Período:
                </Typography>
                <Grid container spacing={2}>
                  <Grid item md={6} sm={6} xs={12}>
                    <LocalizationProvider
                      dateAdapter={AdapterMoment}
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DatePicker
                        value={initialDate}
                        label="Data Inicial"
                        onChange={e => {
                          if (moment(e).isValid()) {
                            setCurrentPage(0);
                            setInitialDate(e);
                          }
                        }}
                        renderInput={params => <TextField {...params} size="small" placeholder="Data Inicial" fullWidth />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item md={6} sm={6} xs={12}>
                    <LocalizationProvider
                      dateAdapter={AdapterMoment}
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DatePicker
                        value={finalDate}
                        label="Data Final"
                        onChange={e => {
                          if (moment(e).isValid()) {
                            setCurrentPage(0);
                            setFinalDate(e);
                          }
                        }}
                        renderInput={params => <TextField {...params} size="small" placeholder="Data Final" fullWidth />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md="auto" sx={{ display: { xs: 'none', md: 'flex' } }}>
                <Divider orientation="vertical" flexItem />
              </Grid>

              <Grid item md sm={12} xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', mb: 1, fontWeight: 500 }}>
                  Filtro:
                </Typography>
                <Grid container spacing={2}>
                  <Grid item md={3} sm={6} xs={12}>
                    <SelectCheckbox
                      label="Situação"
                      size="small"
                      options={state.resourcesWithActions.hasOwnProperty('atestado-digital-rh') ? statusFilters : managerStatusFilters}
                      selectds={statusSelected}
                      onChange={value => {
                        setCurrentPage(0);
                        setStatusSelected(value);
                      }}
                      limitTags={2}
                    />
                  </Grid>
                  <Grid item md={2} sm={6} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="select-integration">Integração</InputLabel>
                      <Select
                        labelId="select-integration"
                        label="Integrado"
                        onChange={data => {
                          setIntegrationSelected(data.target.value);
                          setCurrentPage(0);
                        }}
                        value={integrationSelected}
                        sx={{ height: '40px' }}
                      >
                        {statusIntegration.map(integration => (
                          <MenuItem key={integration.value} value={integration.value}>
                            {integration.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={2} sm={6} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="select-drafts">Rascunhos</InputLabel>
                      <Select
                        labelId="select-drafts"
                        label="Rascunhos"
                        onChange={data => {
                          setAllowDrafts(data.target.value === 'true');
                          setCurrentPage(0);
                        }}
                        value={allowDrafts}
                        sx={{ height: '40px' }}
                      >
                        {statusDrafts.map(integration => (
                          <MenuItem key={integration.index} value={integration.value.toString()}>
                            {integration.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={5} sm={6} xs={12}>
                    <SearchDocumentType documentType={typeDocument} setDocumentType={setTypeDocument} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', mb: 1, fontWeight: 500 }}>
              Busca:
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item md={2} sm={2} xs={12}>
                <SearchCompany
                  setCompany={company => {
                    setCurrentPage(0);
                    setCompany(company);
                    // A lista de filiais é da empresa, então a seleção anterior deixa de valer
                    setSubsidiary(null);
                  }}
                  company={company}
                />
              </Grid>
              <Grid item md={2} sm={2} xs={12}>
                <SearchSubsidiary
                  setSubsidiary={subsidiary => {
                    setCurrentPage(0);
                    setSubsidiary(subsidiary);
                  }}
                  subsidiary={subsidiary}
                  companyId={company?.id}
                />
              </Grid>
              <Grid item md={2} sm={2} xs={12}>
                <SearchCostCenter
                  setCostCenter={costCenter => {
                    setCurrentPage(0);
                    setCostCenters(costCenter);
                  }}
                  costCenter={costCenters}
                />
              </Grid>
              <Grid item md={2} sm={12} xs={12}>
                <SearchLocal
                  setLocal={local => {
                    setCurrentPage(0);
                    setLocal(local);
                  }}
                  local={local}
                />
              </Grid>
              <Grid item md={2} sm={12} xs={12}>
                <FollowupSearchEmployee
                  setEmployee={employee => {
                    setCurrentPage(0);
                    setEmployee(employee);
                  }}
                  employee={employee}
                />
              </Grid>
              <Grid item md={2} sm={16} xs={16}>
                <TextField
                  value={protocolNumber}
                  label="Protocolo"
                  placeholder="Informe o N.° do Protocolo"
                  fullWidth
                  size="small"
                  onChange={e => {
                    setProtocolNumber(e.target.value);
                  }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={1} alignItems="center">
              <Grid item md={2} sm={12} xs={12}>
                <FormControlLabel
                  label="Apenas com Alertas"
                  control={
                    <Checkbox
                      onChange={e => {
                        setOnlyAlerts(e.target.checked);
                      }}
                      checked={onlyAlerts}
                    />
                  }
                />
              </Grid>
              <Grid item md={2} sm={16} xs={16}>
                <Button
                  variant='outlined'
                  size='small'
                  onClick={() => {
                    setEmployee(null);
                    setLocal(null);
                    setOnlyAlerts(false);
                    setProtocolNumber('');
                    setStatusSelected([{ value: 'PENDING', label: 'Pendente' }]);
                    setIntegrationSelected('TODOS');
                    setInitialDate(
                      moment(new Date())
                        .subtract(5, 'days')
                        .startOf('day'),
                    );
                    setFinalDate(moment(new Date()).endOf('day'));
                    setAllowDrafts(false);
                    setTypeDocument(null);
                    setCostCenters(null);
                    setCompany(null);
                    setSubsidiary(null);
                  }}
                >
                  <ClearAllIcon sx={{ mr: 1 }} />
                  Limpar Filtros
                </Button>
              </Grid>
            </Grid>

          </AccordionDetails>
        </Accordion>
      </Box>

      <TableContainer component={Paper} sx={{
        marginTop: 2,
        maxHeight: 'calc(100vh - 160px)',
        overflow: 'auto',
      }}>
        {loading && <LinearProgress />}
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  ...getBaseCellProps(true),
                  position: 'sticky',
                  left: 0,
                  zIndex: 4,
                  width: EVENTOS_WIDTH,
                  minWidth: EVENTOS_WIDTH,
                }}
              >
                Eventos
              </TableCell>
              {headers.map((head, index) => (
                <CustomTableSortLabel
                  key={head.field}
                  sx={getStickyProps(headers, index, true)}
                  perPage={perPage}
                  currentPage={currentPage}
                  orderField={orderField}
                  field={head.field}
                  label={head.label}
                  handleRequest={list}
                  direction={orderDirection}
                  setField={setOrderField}
                  setDirection={setOrderDirection}
                />
              ))}
              <TableCell sx={getBaseCellProps(true)}>Tem Alerta</TableCell>
              <TableCell sx={getStickyRightProps(true)}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {medicalCertificates.length === 0 ? (
              <TableRow>
                <TableCell colSpan={headers.length + 2}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ padding: 1, maxWidth: '100vw' }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', padding: '24px 0' }}>
                      <ManageSearchSharpIcon sx={{ fontSize: 52, color: 'text.disabled' }} />
                      <Box sx={{ fontSize: '1.1rem', fontWeight: 500, color: 'text.secondary' }}>
                        Nenhum registro encontrado
                      </Box>
                    </div>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              medicalCertificates &&
              medicalCertificates.map(medicalCertificateRow => {
                return (
                  <FollowupListRow
                    handleClick={handleOpenDetail}
                    medicalCertificateRow={medicalCertificateRow}
                    seeCID={seeCID}
                    key={medicalCertificateRow.id}
                    headers={headers}
                  />
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomTablePagination
        totalRows={totalRows}
        currentPage={currentPage}
        perPage={perPage}
        handleRequest={list}
        setPerPage={setPerPage}
        setCurrentPage={setCurrentPage}
        orderField={orderField}
        orderDirection={orderDirection}
      />
    </Container>
  );
};

export default FollowupList;
